export default __webpack_public_path__ + "static/media/banner_lima_bahia.fa582801.jpg";